interface ExperienceInfoProps {
    position?: string;
    company?:string;
    date?: string;
}
export function ExperienceInfo({ position, company, date }: ExperienceInfoProps) {
    return (
        <div className="grid grid-cols-2 pb-10">
            <h2 className="text-base font-roboto font-light">{date}</h2>
            <div>
                <h2 className="text-xl font-roboto font-medium">{position}</h2>
                <h3 className="text-lg italic font-roboto">{company}</h3>
            </div>
        </div>
    )
}